import Index from './Payments'
import IndexHeading from './IndexHeading'
import Show from './Show'
import ShowHeading from './ShowHeading'
import ShowPublic from './ShowPublic'

export default {
  Index,
  IndexHeading,
  Show,
  ShowHeading,
  ShowPublic
}



// WEBPACK FOOTER //
// ./src/components/payments/index.js